document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    // Delegated so it survives tab-content swaps.
    page.addEventListener('click', (e) => {
        // Discard / Cancel — revert changes and leave edit mode.
        const cancelBtn = e.target.closest('[data-myaccount-edit-cancel]');
        if (cancelBtn) {
            e.preventDefault();
            const form = cancelBtn.closest('[data-myaccount-form]');
            if (form) cancelEdit(form);
            return;
        }

        const btn = e.target.closest('[data-myaccount-edit-toggle]');
        if (!btn) return;
        e.preventDefault();

        const form = btn.closest('[data-myaccount-form]');
        if (!form) return;

        const isOff = btn.dataset.mode !== 'on';
        if (isOff) {
            enterEditMode(form, btn);
        } else {
            commitSave(form, btn);
        }
    });

    // Fields/dropdowns/buttons marked with [data-myaccount-locked] stay
    // read-only even in edit mode (e.g. email — sourced from the OAuth
    // identity, not editable here).
    function setReadonly(form, readonly) {
        form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]').forEach((el) => {
            if (el.hasAttribute('data-myaccount-locked')) return;
            if (readonly) {
                el.setAttribute('readonly', 'readonly');
            } else {
                el.removeAttribute('readonly');
            }
        });

        form.querySelectorAll('.myaccount__custom-select').forEach((sel) => {
            if (sel.hasAttribute('data-myaccount-locked')) {
                sel.dataset.disabled = 'true';
                sel.classList.remove('open');
                return;
            }
            sel.dataset.disabled = readonly ? 'true' : 'false';
            if (readonly) sel.classList.remove('open');
        });

        const replaceBtn = form.querySelector('.myaccount__file-replace');
        if (replaceBtn && !replaceBtn.hasAttribute('data-myaccount-locked')) {
            if (readonly) replaceBtn.setAttribute('disabled', 'disabled');
            else          replaceBtn.removeAttribute('disabled');
        }
    }

    function enterEditMode(form, btn) {
        clearFormErrors(form);
        form._maSnapshot = snapshotForm(form);   // capture values so Discard can revert
        setReadonly(form, false);

        btn.dataset.mode = 'on';
        btn.setAttribute('aria-label', 'Save changes');
        const icon = btn.querySelector('i');
        if (icon) icon.className = 'ri-check-line';

        toggleCancelBtn(form, true);
        page.dataset.editMode = 'on';

        // Focus the first editable text input for fast editing.
        const first = form.querySelector(
            'input[type="text"]:not([data-myaccount-locked]),' +
            'input[type="email"]:not([data-myaccount-locked]),' +
            'input[type="tel"]:not([data-myaccount-locked])'
        );
        if (first) first.focus();
    }

    function exitEditMode(form, btn) {
        setReadonly(form, true);

        btn.dataset.mode = 'off';
        btn.setAttribute('aria-label', 'Edit profile');
        const icon = btn.querySelector('i');
        if (icon) icon.className = 'ri-pencil-line';

        toggleCancelBtn(form, false);
        page.dataset.editMode = 'off';
    }

    function toggleCancelBtn(form, editing) {
        const cancel = form.querySelector('[data-myaccount-edit-cancel]');
        if (cancel) cancel.hidden = !editing;
    }

    // Snapshot every field value (+ each custom-select's display) so "Discard"
    // can restore the form to how it looked when edit mode was entered.
    function snapshotForm(form) {
        const inputs = [];
        form.querySelectorAll('input[name], textarea[name]').forEach((el) => {
            inputs.push({ el, value: el.value });
        });
        const selects = [];
        form.querySelectorAll('.myaccount__custom-select').forEach((sel) => {
            const span = sel.querySelector('.myaccount__select-trigger span');
            const selected = sel.querySelector('.myaccount__option.selected');
            selects.push({
                sel,
                label: span ? span.textContent : '',
                selectedValue: selected ? (selected.getAttribute('data-value') || '') : null,
            });
        });
        return { inputs, selects };
    }

    function restoreForm(form, snap) {
        if (!snap) return;
        snap.inputs.forEach((s) => { s.el.value = s.value; });
        snap.selects.forEach((s) => {
            const span = s.sel.querySelector('.myaccount__select-trigger span');
            if (span) span.textContent = s.label;
            s.sel.querySelectorAll('.myaccount__option').forEach((o) => {
                o.classList.toggle('selected', (o.getAttribute('data-value') || '') === s.selectedValue);
            });
        });
    }

    function cancelEdit(form) {
        const toggleBtn = form.querySelector('[data-myaccount-edit-toggle]');
        restoreForm(form, form._maSnapshot);
        clearFormErrors(form);
        if (toggleBtn) exitEditMode(form, toggleBtn);
    }

    // Success confirmation shown after the profile saves — same design family
    // as the enrollment / KYC modals (orange check, gradient accent lines).
    function showProfileUpdatedModal() {
        const uid = 'profile-updated-modal';
        if (document.getElementById(uid)) return;

        const check = '<svg width="38" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M5 12.5l4.5 4.5L19 7.5" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const overlay = document.createElement('div');
        overlay.id = uid;
        overlay.style.cssText = 'position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.7);'
            + 'display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
        overlay.innerHTML =
            '<div style="position:relative;background-color:#141417;'
            +   'background-image:linear-gradient(90deg,transparent 0%,rgba(249,115,22,.1) 15%,rgba(249,115,22,.5) 30%,#f97316 50%,rgba(249,115,22,.5) 70%,rgba(249,115,22,.1) 85%,transparent 100%),linear-gradient(90deg,transparent 0%,rgba(249,115,22,.1) 15%,rgba(249,115,22,.5) 30%,#f97316 50%,rgba(249,115,22,.5) 70%,rgba(249,115,22,.1) 85%,transparent 100%);'
            +   'background-size:20% 2px,20% 2px;background-position:10% 0,90% 100%;background-repeat:no-repeat;'
            +   'border:1px solid #26262b;border-radius:24px;max-width:720px;width:100%;padding:56px;text-align:center;box-shadow:0 24px 64px rgba(0,0,0,.55);">'
            +   '<button type="button" data-close aria-label="Close" style="position:absolute;top:18px;right:20px;background:none;border:none;cursor:pointer;color:#f97316;font-size:24px;line-height:1;padding:4px;">&times;</button>'
            +   '<div style="width:80px;height:80px;margin:0 auto 24px;border-radius:50%;background:#f97316;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 10px rgba(249,115,22,.10), 0 0 30px 6px rgba(249,115,22,.45);">' + check + '</div>'
            +   '<h3 style="font-size:30px;color:#fff;margin:0 0 22px;font-weight:600;line-height:1.25;">Profile Updated<br>Successfully.</h3>'
            +   '<p style="font-size:15px;color:#9a9aa2;margin:0;">Start Your Practical Learning</p>'
            + '</div>';

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        function close() { overlay.remove(); document.body.style.overflow = ''; }
        overlay.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', close));
        overlay.addEventListener('click', (ev) => { if (ev.target === overlay) close(); });
    }

    // Backend concatenates dob_year + "-" + dob_month + "-" + dob_date as the
    // Portal `date_of_birth`, which MySQL stores as DATE — so the month must be
    // numeric ("03"), not the short name ("Mar") shown in the dropdown.
    const MONTH_TO_NUMBER = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
        Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12',
    };

    function buildSubmitData(form) {
        const fd = new FormData(form);
        const month = fd.get('dob_month');
        if (typeof month === 'string' && MONTH_TO_NUMBER[month]) {
            fd.set('dob_month', MONTH_TO_NUMBER[month]);
        }
        return fd;
    }

    async function commitSave(form, btn) {
        if (btn.disabled) return;
        btn.disabled = true;
        clearFormErrors(form);

        try {
            const response = await fetch('/api/student/profile', {
                method: 'POST',
                body:   buildSubmitData(form),
                credentials: 'same-origin',
            });

            if (response.ok) {
                exitEditMode(form, btn);
                showProfileUpdatedModal();
                return;
            }

            // Validation errors come back as `{ error: { fieldName: "msg", ... } }`.
            // Other failures may send `{ error: "<raw upstream payload>" }` or no body at all.
            let payload = {};
            try { payload = await response.json(); } catch (_) {}
            showFormError(form, payload && payload.error);
        } catch (err) {
            console.error('myaccount: profile save failed', err);
            showFormError(form, 'Network error — please try again.');
        } finally {
            btn.disabled = false;
        }
    }

    function clearFormErrors(form) {
        const banner = form.querySelector('.myaccount__form-error');
        if (banner) banner.remove();
        form.querySelectorAll('.myaccount__field--invalid')
            .forEach((field) => field.classList.remove('myaccount__field--invalid'));
        form.querySelectorAll('.myaccount__field-error').forEach((msg) => msg.remove());
    }

    function clearFieldError(field) {
        field.classList.remove('myaccount__field--invalid');
        const msg = field.querySelector('.myaccount__field-error');
        if (msg) msg.remove();
    }

    // Prefer the field's own visible <label> — the templates carry proper
    // labels even where the server's labels() map is incomplete (which is why
    // raw keys like "student_mobile_number" leaked into the old error banner).
    function fieldLabelText(field, key) {
        const labelEl = field && field.querySelector('.myaccount__field-label');
        const text = (labelEl ? labelEl.textContent : '').replace(/\*/g, '').trim();
        if (text) return text;
        return String(key).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    }

    // Resolve a server error key to its field container. The ID attachment has
    // no named <input> (uploaded via $_FILES) — it's the .myaccount__file block.
    function fieldForKey(form, key) {
        if (key === 'custom_id_attachment_url') {
            const file = form.querySelector('.myaccount__file');
            return file ? file.closest('.myaccount__field') : null;
        }
        const control = form.querySelector('[name="' + key + '"]');
        return control ? control.closest('.myaccount__field') : null;
    }

    function markFieldInvalid(field, message) {
        field.classList.add('myaccount__field--invalid');
        let msgEl = field.querySelector('.myaccount__field-error');
        if (!msgEl) {
            msgEl = document.createElement('p');
            msgEl.className = 'myaccount__field-error';
            msgEl.setAttribute('role', 'alert');
            field.appendChild(msgEl);
        }
        msgEl.textContent = message;
    }

    // Renders validation errors on the spot: a red border + a specific message
    // under each offending field, instead of one run-on banner at the top.
    function showFormError(form, error) {
        const FIELD_MESSAGE_MAX = 200;

        if (error && typeof error === 'object' && !Array.isArray(error)) {
            const entries = Object.entries(error);
            const looksLikeValidation = entries.length > 0 && entries.every(
                ([, v]) => typeof v === 'string' && v.length > 0 && v.length <= FIELD_MESSAGE_MAX
            );

            if (looksLikeValidation) {
                const marked = new Set();
                const unmapped = [];
                let firstInvalid = null;

                entries.forEach(([key, serverMsg]) => {
                    const field = fieldForKey(form, key);
                    if (!field) { unmapped.push([key, serverMsg]); return; }
                    if (marked.has(field)) return;   // one message per field (e.g. the DOB trio)
                    marked.add(field);

                    // Keep a friendly server message; rebuild raw ones (with
                    // underscores) from the field's own label.
                    let message = serverMsg;
                    if (!message || /_/.test(message)) {
                        message = fieldLabelText(field, key) + ' is required';
                    }
                    markFieldInvalid(field, message);
                    if (!firstInvalid) firstInvalid = field;
                });

                // Never silently drop an error we couldn't map to a field.
                if (unmapped.length) {
                    showBanner(form, unmapped.map(([k, v]) => (
                        (!v || /_/.test(v)) ? k.replace(/_/g, ' ') + ' is required' : v
                    )).join(' '));
                }

                if (firstInvalid) {
                    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    const focusable = firstInvalid.querySelector('input:not([type="hidden"]):not([readonly]), .myaccount__select-trigger');
                    if (focusable && typeof focusable.focus === 'function') focusable.focus();
                }
                return;
            }

            console.error('myaccount: profile save error payload', error);
            showBanner(form, 'Could not save your profile. Please try again.');
            return;
        }

        if (typeof error === 'string' && error.length > 0 && error.length <= FIELD_MESSAGE_MAX) {
            showBanner(form, error);
        } else {
            if (error) console.error('myaccount: profile save error payload', error);
            showBanner(form, 'Could not save your profile. Please try again.');
        }
    }

    // Fallback banner for non-field or unmappable errors.
    function showBanner(form, message) {
        let banner = form.querySelector('.myaccount__form-error');
        if (!banner) {
            banner = document.createElement('div');
            banner.className = 'myaccount__form-error text-danger';
            banner.setAttribute('role', 'alert');
            form.prepend(banner);
        }
        banner.textContent = message;
    }

    // On-the-spot clearing: as soon as the user corrects a flagged field
    // (typing in an input or picking a dropdown option), drop its error.
    page.addEventListener('input', (e) => {
        const field = e.target.closest('.myaccount__field--invalid');
        if (field) clearFieldError(field);
    });
    page.addEventListener('change', (e) => {
        const field = e.target.closest('.myaccount__field--invalid');
        if (field) clearFieldError(field);
    });
    page.addEventListener('click', (e) => {
        const option = e.target.closest('.myaccount__option');
        if (!option) return;
        const field = option.closest('.myaccount__field--invalid');
        if (field) clearFieldError(field);
    });
});
